import { z } from 'zod';

export const BrandCartUiTutorialSlide = z.object({
    guid: z.string(),
    title: z.string().nullish(),
    image: z.string().nullish(),
    description: z.string().nullish(),
});
export type BrandCartUiTutorialSlide = z.infer<typeof BrandCartUiTutorialSlide>;
